<!--
Author: TangChen
Date: 2018-10-17
Desc: 绑定交易账户，由index.js 配置引入
 -->
<template>
    <div class="bizcomp-bind-new-acct bizcomp">
        <bind-acct-dc :way="way" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import bindAcctDc from "@/components/acctInfo/bindAcctDc.vue";
export default {
    name: "BindNewAcct",
    components: {
        bindAcctDc
    },
    mixins: [mixin],
    data() {
        return {
            way: false
        };
    },
    methods: {
        // 账户绑定选项处理
    }
};
</script>
<style lang="scss">
.bizcomp-bind-new-acct {
    margin-bottom: 20px;
}
</style>
